<template>
  <div class='flex items-center justify-center h-screen w-screen'>
    <p class='text-xl font-semibold'>Welcome to GBCC2025</p>
  </div>
</template>

<script>
export default {
  name: 'Main'
}
</script>

<style scoped>
</style>
